import React, { useLayoutEffect } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import HeaderButton from '../../../components/Buttons/HeaderButton';
import MainButton from '../../../components/Buttons/MainButton';
import UsersList from './components/UsersList';

const UsersScreen = ({ navigation }) => {
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTitle: 'Users',
            headerRight: () => (
                <HeaderButton
                    onPress={() => { navigation.navigate('AdminCreateUser') }}
                    accessibilityLabel="Create new user"
                    accessibilityHint="Press this button to create a new user"
                    buttonText="Create"
                />
            ),
            headerLeft: null
        });
    }, [navigation]);

    const CreateButtonComponent = (
        <MainButton
            onPress={() => { navigation.navigate('AdminCreateUser') }}
            text={'Create User'}
            accessibilityLabel="Create new user"
            accessibilityHint="Press this button to create a new user"
        />
    )

    return (
        <View style={styles.screen}>
            <UsersList
                onEmptyUserListCreateBtnPress={() => { navigation.navigate('AdminCreateUser') }}
                ListFooterComponent={CreateButtonComponent}
                onEditButtonPress={(userId) => navigation.navigate('AdminEditUser', {
                    userId: userId
                })}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    screen: {
        flex: 1
    }
});

export default UsersScreen;